import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default function useNumber() {
  const { locale } = useI18n()

  const postiveNumber = (number: string, from: number, to?: number) => {
    const numberIsSuperior = Number.isInteger(Number(number)) && Number(number) > from
    if (to) {
      return numberIsSuperior && Number(number) < to
    } else {
      return numberIsSuperior
    }
  }

  const formatPhoneNumber = (phoneNumber: string | null | undefined) => {
    if (!phoneNumber) return null
    const parsed = parsePhoneNumberFromString(phoneNumber, 'FR')
    if (!parsed?.isValid()) return phoneNumber
    return parsed.country === 'FR' ? parsed.formatNational() : parsed.formatInternational()
  }

  const roundNumber = (value: string | number, decimals: number) => {
    return parseFloat(Number(value).toFixed(decimals))
  }

  const formatCurrency = (number: number) => {
    return new Intl.NumberFormat(locale.value, { style: 'currency', currency: 'EUR' }).format(number)
  }

  const formatNumber = (number?: unknown, isCurrency?: boolean, decimals?: number): string | number => {
    if (!number) {
      return 0
    }
    if (!Number.isFinite(Number(number))) {
      return String(number)
    }
    const defaultOptions: Intl.NumberFormatOptions = isCurrency
      ? {
          style: 'currency',
          currency: 'EUR',
          maximumFractionDigits: decimals ?? 0
        }
      : {}

    const formattedNumber = new Intl.NumberFormat(locale.value, defaultOptions).format(Number(number))
    return formattedNumber
  }

  const formatPercentage = (value: number | string, decimals: number = 2) => {
    if (!value) {
      return '0%'
    }

    return new Intl.NumberFormat(locale.value, {
      style: 'percent',
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(Number(value) / 100)
  }

  const formatFloatAndIntegerKeys = ({
    e,
    isIntegerOnly,
    type
  }: {
    e: KeyboardEvent
    isIntegerOnly: boolean
    type: string
  }) => {
    const blockedKeysForFloat = ['e', 'E', '+', '-']
    const blockedKeysForInteger = ['e', 'E', '+', '-', '.', ',']

    if (isIntegerOnly && blockedKeysForInteger.includes(e.key)) {
      e.preventDefault()
    }
    if (!isIntegerOnly && blockedKeysForFloat.includes(e.key) && type === 'number') {
      e.preventDefault()
    }
  }

  return {
    formatFloatAndIntegerKeys,
    postiveNumber,
    formatPhoneNumber,
    roundNumber,
    formatCurrency,
    formatNumber,
    formatPercentage
  }
}
